import colors from "../../base/colors";

const { text } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      color: text.secondary,
      fontSize: "0.875rem",
      fontWeight: 500,
      marginBottom: "0.25rem",
    },
  },
};

export default formLabel;
